import { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { IconButton, Typography } from "@mui/material";
import {
  Delete,
  Info,
  DownloadForOffline,
  Check,
  DoneAll,
} from "@mui/icons-material";
import { closeModal, openModal } from "../../store/actions/modalAction";
import moment from "moment";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { APPRAISAL_STATUS, SNACK_BAR_VARIETNS } from "../../utils/constants";
import {
  fetchAllUserAppresialApi,
  deleteAppresialDetailsApi,
} from "../../apis/appresial.api";
import AppresialLetterListUI from "./AppresialLetterListUI";
import ApprasialLetterUi from "./ApprasialLetterUI";
import DownloadApprasialLetterPdf from "./DownloadApprasialLetterPdf";
import PreviewTableController from "./PreviewTableController";
import PreviewIndividualTable from "./PreviewIndividualTable";
import DownloadApprasialLetterPdfButton from "./DownloadApprasialLetterPdfButton";
// import DownloadSalarySlipListPdf from "../payrollSummary/DownloadSalarySlipListPdf"

const ActionButton = ({ params, setParams, date }) => {
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const onClick = () => {
    // dispatch(

    dispatch(
      openModal({
        title: "Sheet Preview",
        component: (
          <PreviewIndividualTable
            // fields={fields}
            //  data={data} date={date.valueOf()}
            // date={moment(date)} emp_id={params.employee_id}
            params={params}
          ></PreviewIndividualTable>
        ),
      })
    );
    // )
  };


  const onDelete = () => {
    setLoading(true);
    const year = moment(date).get("year");
    dispatch(
      callApiAction(
        async () =>
          await deleteAppresialDetailsApi({
            employee_id: params.employee_id,
            year,
          }),
        (response) => {
          setLoading(false);
          setParams({});
          dispatch(
            callSnackBar(
              "Appraisal Details Deleted",
              SNACK_BAR_VARIETNS.suceess
            )
          );
        },
        (err) => {
          setLoading(false);
          dispatch(
            callSnackBar("Can not delete Branch", SNACK_BAR_VARIETNS.error)
          );
        }
      )
    );
    dispatch(closeModal());
  };
  const onDltBtnCLick = () => {
    dispatch(
      openModal({
        title: "Alert!",
        component: (
          <Typography>
            {"Are sure to want to delete " +
              params.employee_id +
              " Appraisal details?"}
          </Typography>
        ),
        onConfirm: onDelete,
        size: "sm",
        confirmText: "Delete",
        onCancle: () => dispatch(closeModal()),
      })
    );
  };
  return (
    <>
      <IconButton onClick={onClick}>
        <Info color="info" />
      </IconButton>
      <IconButton onClick={onDltBtnCLick}>
        <Delete color="error" />
      </IconButton>
      {/* <IconButton onClick={onDownload}>
        <Check color="" />
      </IconButton> */}
    </>
  );
};

const AppresialLetterListController = ({ date }) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAppresial = fetchAllUserAppresialApi;

  const columns = useMemo(
    () => [
      {
        id: 0,
        fieldName: "employee_id",
        label: "Employee Id",
        align: "left",
        sort: true,
      },
  
      {
        id: 2,
        fieldName: "action",
        label: "action",
        align: "left",
        minWidth: "150px",
        renderValue: (params, setParams) => (
          <>
            <DownloadApprasialLetterPdfButton
              date={moment(date)}
              emp_id={params.employee_id}
            />
            <ActionButton
              key={date}
              date={date}
              params={params}
              setParams={setParams}
            />
          </>
        ),
      },
    ],
    [dispatch, date]
  );

  const [filters, setFilters] = useState({
    pageSize: 10,
    pageNo: 1,
    sort: "employee_id",
    searchable: ["employee_id"],
    sortDirection: -1,
    status: null,
  });

  const fetchList = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await fetchAppresial({ ...filters, date: date }),
        (response) => {
          setState(response);

          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    fetchList();
  }, [filters, date]);

  return (
    <AppresialLetterListUI
      date={date}
      columns={columns}
      filters={filters}
      setFilters={setFilters}
      setState={setState}
      callBack={fetchList}
      loading={loading}
      state={state}
    />
  );
};
export default memo(AppresialLetterListController);
